import { usePath } from "@fdoh/health-ui-react";
import { useHistory } from "react-router-dom";
import { ApplicationInspectionRequest, SearchResultsProps } from "./SearchResults.types";
import useClient from "../../hooks/useInspectionClient";
import { toast } from "react-toastify";
import { useAppConfig } from "@fdoh/health-ui-react";
import useProfile from "../../hooks/useProfile";
import { UserSecurityInput } from "../../components/DBProtectedRoute.types";
import { createContext, useContext, useState, useRef, useEffect } from "react";
import { useData } from "../../hooks";
import { InspectionStatusInput } from "../InspectionHome/InspectionHome.types";
import { InspectionHistoryPage } from "./InspectionHistory";
import { InspectionHistoryData } from "./InspectionHistory.types";

export const SearchResultsPage = (props: SearchResultsProps) => {

    const history = useHistory();
    const path = usePath();
    const client = useClient();
    const inputRef = useRef<HTMLInputElement>(null);
    const [inspectionHistoryData, setInspectionHistoryData] = useState<InspectionHistoryData[]>([]);
    const showHidePreviousInspections = props.showHidePreviousInspections;
    const setShowPreviousInspections = props.setShowPreviousInspections;
    const [showHideHistoryButton, setShowHideHistoryButton] = useState(false);
    const applicationData = props.appData;
    const applicationNumber = props.apNumber;
    const config = useAppConfig();
    const application = config.applications.filter(x => x.name === "privateProviderInspectionApi")[0];
    const userStatus = useProfile(application) as UserSecurityInput;
    //const [currentApNumber, setCurrentApNumber] = useState<string>("");

    const goToInspectionHome = () => {
        //history.push(`/inspectionDetails/` + applicationData?.applicationInspections?.filter(x => x.inspectionStatusId === 1)[0].applicationInspectionId);
        const inspectionId = applicationData?.applicationInspections?.filter(x => x.inspectionStatusId === 1)[0].applicationInspectionId;
        history.push({
            pathname: `/inspectionDetails/${inspectionId}`,
            state: {
                applicationNumber: applicationData?.apnumber
            }
        });
    }

    const createNew = async () => {
        const createinspectionHistoryData: ApplicationInspectionRequest = {
            applicationId: applicationData?.applicationId,
            inspectionStatusId: 1,
            isApproved: false,
            providerId: 0,
            dateCreated: new Date(),
            createdBy: userStatus.userName,
            dateUpdated: new Date(),
            updatedBy: userStatus.userName,
            userId: userStatus.userSecurityId,
        };
        try {
            let endpoint = 'ApplicationInspection/';
            const inspectionResponse = await client.api(endpoint).post(createinspectionHistoryData);
            //history.push(`/inspectionDetails/${inspectionResponse.data?.id}`);
            history.push({
                pathname: `/inspectionDetails/${inspectionResponse.data?.id}`,
                state: {
                    applicationNumber: applicationData?.apnumber
                }
            });
        } catch (error: any) {
            toast.error(error);
        }
    }

    useEffect(() => {
        if (!showHidePreviousInspections) {
            setInspectionHistoryData([]);
        }
    }, [showHidePreviousInspections]);

    const handleInspectionsToggle = () => {
        if (setShowPreviousInspections) {
            if (showHidePreviousInspections) {
                setShowPreviousInspections(false);
                setInspectionHistoryData([]); // Clear data when hiding
            } else {
                setShowPreviousInspections(true);
                previousInspections();
            }
        }
    }

    const previousInspections = async () => {
        try {
            let endpoint = 'Application/getFinalInspectionHistory/' + props.apNumber//inputRef.current?.value;
            const response = await client.api(endpoint).get();
            if (response.data && Array.isArray(response.data)) {
                setInspectionHistoryData(response.data);
                setShowHideHistoryButton(true);
            } else {
                setInspectionHistoryData([]);
                setShowHideHistoryButton(false);
            }
        } catch (error: any) {
            setInspectionHistoryData([]);
            setShowHideHistoryButton(false);
            toast.error(error);
        }
    }

    return applicationData ? (
        <div>
            {applicationData && (applicationData?.applicationInspections?.filter(x => x.inspectionStatusId === 1).length > 0) && (
                <>
                    <div className="card-body">
                        <div className="row g-2 align-items-center">
                            <div className="col-auto">
                                <div className="bg-welcome msg">Search results</div>
                            </div>
                            <div className="col-auto text-muted">
                                Showing results for '{props.apNumber}'
                            </div>
                        </div>
                    </div>
                    <button className="card card-link w-100" onClick={goToInspectionHome} title="Open Inspection">
                        <div className="card-body w-100">
                            <div className="row">
                                <div className="col-auto">
                                    <div className="datagrid-item">
                                        <div className="datagrid-title">AP#</div>
                                        <div className="datagrid-content">{applicationData.apnumber}</div>
                                    </div>
                                </div>
                                <div className="col">
                                    <div className="datagrid-item">
                                        <div className="datagrid-title">Permit Date</div>
                                        <div className="datagrid-content">{new Date(applicationData.permitDate).toLocaleDateString()}</div>
                                    </div>
                                </div>
                                <div className="col">
                                    <div className="datagrid-item">
                                        <div className="datagrid-title">PROPERTY ADDRESS</div>
                                        <div className="datagrid-content">{applicationData.propertyStreetAddress + ", " + applicationData.propertyCity + ", " + applicationData.propertyState + ", " + applicationData.propertyZipCode}</div>
                                    </div>
                                </div>
                                <div className="col-auto">
                                    <span className="avatar rounded"><svg xmlns="http://www.w3.org/2000/svg" className="icon icon-tabler icon-tabler-chevron-right" width="24" height="24" viewBox="0 0 24 24" stroke-width="2" stroke="currentColor" fill="none" stroke-linecap="round" stroke-linejoin="round">
                                        <path stroke="none" d="M0 0h24v24H0z" fill="none"></path>
                                        <path d="M9 6l6 6l-6 6"></path>
                                    </svg></span>
                                </div>
                            </div>
                        </div>
                    </button>
                    <br></br>
                    <div className="btn btn-primary" style={{ cursor: 'pointer' }} onClick={handleInspectionsToggle}>
                        {showHidePreviousInspections ? 'Hide Previous Inspections' : 'View Previous Inspections'}
                    </div>
                </>
            )}
            {applicationData &&
                (applicationData?.applicationInspections?.length === 0 || applicationData?.applicationInspections?.filter(x => x.inspectionStatusId === 1).length === 0)
                && (

                    <div className="align-items-center">
                        <div>
                            {/* <div className="bg-welcome msg">No results found for '{applicationNumber}'</div>*/}
                            <>

                                <div className="card-body w-100">
                                    <div className="row">
                                        <div className="col-auto">
                                            <div className="datagrid-item">
                                                <div className="datagrid-title">AP#</div>
                                                <div className="datagrid-content">{applicationData.apnumber}</div>
                                            </div>
                                        </div>
                                        <div className="col">
                                            <div className="datagrid-item">
                                                <div className="datagrid-title">Permit Date</div>
                                                <div className="datagrid-content">{new Date(applicationData.permitDate).toLocaleDateString()}</div>
                                            </div>
                                        </div>
                                        <div className="col">
                                            <div className="datagrid-item">
                                                <div className="datagrid-title">PROPERTY ADDRESS</div>
                                                <div className="datagrid-content">{applicationData.propertyStreetAddress + ", " + applicationData.propertyCity + ", " + applicationData.propertyState + ", " + applicationData.propertyZipCode}</div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </>
                            <div className="d-flex gap-3 justify-content-center">
                                <button className="btn btn-primary flex-column align-items-center" style={{ maxWidth: '300px' }} onClick={createNew}>Create New Inspection</button>
                                <div className="btn btn-primary" style={{ cursor: 'pointer' }} onClick={handleInspectionsToggle}>
                                    {showHidePreviousInspections ? 'Hide Previous Inspections' : 'View Previous Inspections'}
                                </div>
                            </div>
                        </div>
                    </div>

                )}

            {(parseInt(applicationData?.applicationId) == 0) && (
                <p className="bg-welcome msg">
                    No Results found for '{props.apNumber}'
                </p>
            )}

            {/* Inspection History */}
            <div className="row mt-4">
                {showHidePreviousInspections && inspectionHistoryData && applicationData && (
                    <div className="card text-primary-fg">
                        <InspectionHistoryPage
                            appData={inspectionHistoryData}
                            apNumber={props.apNumber?.toString() ? props.apNumber : ''}
                        />
                    </div>
                )}
            </div>
        </div>
    ) : <div>
    </div>
};

export default SearchResultsPage;


